export const SET_IS_LOADING = 'VEHICLE_DAMAGE/SET_IS_LOADING';
export const SET_VEHICLE_DAMAGE_LIST = 'VEHICLE_DAMAGE/SET_VEHICLE_DAMAGE_LIST';